import type { ApiClient } from '@/helpers/apiClient'
import {
  apiRequestDetailDtoSchema,
  apiRequestListDtoSchema,
  type ApiRequestDetailDto,
  type ApiRequestListDto,
} from '@lib/dto/request-log.dto'
import type { TenantMode } from '@lib/enums/tenant-mode.enum'
import type { ApiRequestQuery } from '@lib/input/request-log.input'
import type { Uuid } from '@lib/validators/params'
import type { IRequestLogService } from '@/types/RequestLogService.types'

function base(tenantId: Uuid, mode: TenantMode): string {
  return `/dashboard/tenants/${encodeURIComponent(tenantId)}/modes/${mode}/requests`
}

/** The request log, bound to a dashboard session's client. */
export class RequestLogService implements IRequestLogService {
  constructor(private readonly client: ApiClient) {}

  list(tenantId: Uuid, mode: TenantMode, query: ApiRequestQuery): Promise<ApiRequestListDto> {
    const params = new URLSearchParams()
    for (const [key, value] of Object.entries(query)) {
      if (value) params.set(key, value)
    }
    const search = params.toString()
    return this.client.get(`${base(tenantId, mode)}${search ? `?${search}` : ''}`, apiRequestListDtoSchema)
  }

  detail(tenantId: Uuid, mode: TenantMode, id: Uuid): Promise<ApiRequestDetailDto> {
    return this.client.get(`${base(tenantId, mode)}/${encodeURIComponent(id)}`, apiRequestDetailDtoSchema)
  }
}
